// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"79":"24272e2a6654cce4d0be","661":"ead3735cb9a368c93146","907":"3f071f91354678eb346c"}[chunkId] + ".bundle.js";
};